var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_2138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.375 29.375H15.625C12.875 29.375 10.625 27.125 10.625 24.375V15.625C10.625 12.875 12.875 10.625 15.625 10.625H24.375C27.125 10.625 29.375 12.875 29.375 15.625V24.375C29.375 27.125 27.125 29.375 24.375 29.375Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.375C22.4162 24.375 24.375 22.4162 24.375 20C24.375 17.5838 22.4162 15.625 20 15.625C17.5838 15.625 15.625 17.5838 15.625 20C15.625 22.4162 17.5838 24.375 20 24.375Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.125 14.375C25.125 14.444 25.069 14.5 25 14.5C24.931 14.5 24.875 14.444 24.875 14.375C24.875 14.306 24.931 14.25 25 14.25C25.069 14.25 25.125 14.306 25.125 14.375Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_2138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.3061b2fa2f4a8b63d287f68351815b10.svg";
export { ForwardRef as ReactComponent };